import { SwapMode } from '../common/types';
export const serializeQuoteKey = (params) => {
    const { pairId, amount, slippage = 0, fromAddress = '', swapMode = SwapMode.ExactIn } = params;
    return `${pairId}-${amount.toDefaultString()}-${slippage}-${fromAddress}-${swapMode}`;
};
export const parseFetchivalError = async (error) => {
    if (error.response) {
        const status = error.response.status;
        const statusText = error.response.statusText;
        const errorData = await error.response
            .clone()
            .json()
            .catch(() => ({}));
        let errorDetails = errorData.error || errorData.details || errorData.message;
        if (!errorDetails) {
            errorDetails = Object.values(errorData).join(', ');
        }
        return `${status}:${statusText ? ` ${statusText} - ` : ' '}${errorDetails}`;
    }
    return `Failed to get order details due to network error: ${error.message || 'Unknown error'}`;
};
